<template>
  <div class="d-flex flex-column text-left">
    <div class="d-flex align-items-center">
      <Tooltip
        v-if="helpTxt"
        :help-text="helpTxt"
        help-id="name-link"
        :label="title"
      />
      <span class="font-weight-bold text-left">{{ title }}</span>
    </div>
    <div v-if="data">
      <link-wrapper v-if="data.link" :link="data.link" :name="data.name" />
      <span v-else>{{ data.name }}</span>
    </div>
  </div>
</template>

<script>
import LinkWrapper from "../common/LinkWrapper.vue";
import Tooltip from "@/components/common/Tooltip.vue";

export default {
  components: { LinkWrapper, Tooltip },
  mounted() {},
  props: ["data", "title", "helpTxt"],
};
</script>
